// import './App.css';
import React from 'react';
import Main from './Components/Main';
import './Components/style.css';

function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
